import React from "react";

const StepStart = ({ allReady, onStart }) => (
  <button
    className={`w-full py-4 rounded-xl text-xl font-bold transition-colors shadow bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:from-blue-600 hover:to-blue-800 disabled:opacity-40 disabled:cursor-not-allowed`}
    onClick={onStart}
    disabled={!allReady}
  >
    AI에게 맡기기
  </button>
);

export default StepStart; 